import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import QuienesSomos from './pages/QuienesSomos';
import QueOfrecemos from './pages/QueOfrecemos';
import Experiencias from './pages/Experiencias';
import ExperienciaDetalle from './pages/ExperienciaDetalle';
import Colaboradores from './pages/Colaboradores';
import Contacto from './pages/Contacto';
import Noticias from './pages/Noticias';
import NoticiaDetalle from './pages/NoticiaDetalle';
import Minisite from './pages/Minisite';

import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminExperiencias from './pages/admin/AdminExperiencias';
import AdminEquipo from './pages/admin/AdminEquipo';
import AdminColaboradores from './pages/admin/AdminColaboradores';
import AdminOfrecemos from './pages/admin/AdminOfrecemos';
import AdminNoticias from './pages/admin/AdminNoticias';
import AdminMinisites from './pages/admin/AdminMinisites';
import AdminMinisiteEditor from './pages/admin/AdminMinisiteEditor';
import AdminMedia from './pages/admin/AdminMedia';
import AdminInscripciones from './pages/admin/AdminInscripciones';
import AdminContactos from './pages/admin/AdminContactos';
import AdminNewsletter from './pages/admin/AdminNewsletter';
import AdminAjustes from './pages/admin/AdminAjustes';

import { Toaster } from './components/ui/toaster';
import { SettingsProvider } from './lib/SettingsContext';
import { AdminAuthProvider } from './lib/AdminAuthContext';
import { LangProvider } from './lib/i18n';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <SettingsProvider>
            <LangProvider>
            <ScrollToTop />
            <Routes>
              {/* Public site — Spanish (default, no prefix) */}
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/quienes-somos" element={<QuienesSomos />} />
                <Route path="/que-ofrecemos" element={<QueOfrecemos />} />
                <Route path="/experiencias" element={<Experiencias />} />
                <Route path="/experiencias/:id" element={<ExperienciaDetalle />} />
                <Route path="/noticias" element={<Noticias />} />
                <Route path="/noticias/:slug" element={<NoticiaDetalle />} />
                <Route path="/colaboradores" element={<Colaboradores />} />
                <Route path="/contacto" element={<Contacto />} />
                <Route path="/m/:slug" element={<Minisite />} />

                {/* English */}
                <Route path="/en" element={<Home />} />
                <Route path="/en/quienes-somos" element={<QuienesSomos />} />
                <Route path="/en/que-ofrecemos" element={<QueOfrecemos />} />
                <Route path="/en/experiencias" element={<Experiencias />} />
                <Route path="/en/experiencias/:id" element={<ExperienciaDetalle />} />
                <Route path="/en/noticias" element={<Noticias />} />
                <Route path="/en/noticias/:slug" element={<NoticiaDetalle />} />
                <Route path="/en/colaboradores" element={<Colaboradores />} />
                <Route path="/en/contacto" element={<Contacto />} />
                <Route path="/en/m/:slug" element={<Minisite />} />

                {/* French */}
                <Route path="/fr" element={<Home />} />
                <Route path="/fr/quienes-somos" element={<QuienesSomos />} />
                <Route path="/fr/que-ofrecemos" element={<QueOfrecemos />} />
                <Route path="/fr/experiencias" element={<Experiencias />} />
                <Route path="/fr/experiencias/:id" element={<ExperienciaDetalle />} />
                <Route path="/fr/noticias" element={<Noticias />} />
                <Route path="/fr/noticias/:slug" element={<NoticiaDetalle />} />
                <Route path="/fr/colaboradores" element={<Colaboradores />} />
                <Route path="/fr/contacto" element={<Contacto />} />
                <Route path="/fr/m/:slug" element={<Minisite />} />
              </Route>

              {/* Admin */}
              <Route path="/admin" element={<AdminLogin />} />
              <Route element={<AdminLayout />}>
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/experiencias" element={<AdminExperiencias />} />
                <Route path="/admin/equipo" element={<AdminEquipo />} />
                <Route path="/admin/colaboradores" element={<AdminColaboradores />} />
                <Route path="/admin/ofrecemos" element={<AdminOfrecemos />} />
                <Route path="/admin/noticias" element={<AdminNoticias />} />
                <Route path="/admin/minisites" element={<AdminMinisites />} />
                <Route path="/admin/minisites/:id" element={<AdminMinisiteEditor />} />
                <Route path="/admin/media" element={<AdminMedia />} />
                <Route path="/admin/inscripciones" element={<AdminInscripciones />} />
                <Route path="/admin/contactos" element={<AdminContactos />} />
                <Route path="/admin/newsletter" element={<AdminNewsletter />} />
                <Route path="/admin/ajustes" element={<AdminAjustes />} />
              </Route>
            </Routes>
            <Toaster />
            </LangProvider>
          </SettingsProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
